import {
    sourceSetFilter,
    sourceClearFilterCriteria,
    sourceApplyFilterCriteria
} from "../../../actions/source-actions"

import buildFilterWidgetContainer from "../../common/build-filter-widget-container"

import SourceFilterFormContainer from "./SourceFilterFormContainer"

export default buildFilterWidgetContainer(
    SourceFilterFormContainer,
    sourceClearFilterCriteria,
    sourceApplyFilterCriteria,
    sourceSetFilter
)
